import { render, staticRenderFns } from "./FinancialDataKorrekturen.vue?vue&type=template&id=74c20a60&scoped=true"
import script from "./FinancialDataKorrekturen.vue?vue&type=script&lang=js"
export * from "./FinancialDataKorrekturen.vue?vue&type=script&lang=js"
import style0 from "./FinancialDataKorrekturen.vue?vue&type=style&index=0&id=74c20a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c20a60",
  null
  
)

export default component.exports